import React from "react";

const PartnersTopNew = ({ partnersTopData = [] }) => {

    if (!partnersTopData.length) return null;

    return (
        <section className="md:bg-[#faf9ff] py-[30px]
            lg:py-[50px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col gap-8 md:flex-row md:justify-center md:flex-wrap  lg:gap-[40px] xl:gap-[70px]">

                    {partnersTopData.map(({partners_top_select: {partners_top_status, partners_top_item}}, groupIndex) => (
                        <div className={`flex flex-col items-center md:flex-row md:justify-center md:gap-6 toppartner-new-${groupIndex} key=${groupIndex}`}>
                            {/* Название */}
                            <h3 className="font-light text-lg lg:text-xl ">{partners_top_status}</h3>
                            {/* Лого */}
                            <div className="">
                                {partners_top_item.map(({acf: {p_url, p_thumbnail, p_logo_width}}, partnerIndex) => (
                                    <a key={`${groupIndex}-${partnerIndex}`}
                                        href={p_url ? p_url : '/'}
                                        className=""
                                        target="_blank"
                                        rel="noopener noreferrer" >
                                        <img  src={p_thumbnail} alt={partners_top_status}className="max-w-[120px]"/>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
        </div>
        </section>
    );
};

export default PartnersTopNew;